import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    minHeight: 0,
    gap: 0,
  },
  listSection: {
    flex: '1 1 100%',
    minWidth: 0,
    transition: 'flex 0.3s ease',
  },
  listSectionWithPanel: {},
}));
